export function formatOdometer(odometer: number | undefined): string {
  if (!odometer) return "0";

  return odometer.toLocaleString("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
}
